module.exports = __webpack_public_path__ + "img/intro_s3_icon2.48ce6c01.png";